import {API_VERSION} from '@/utils/constants/commonConstants'
import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const TARGETS_CONFIG = {
  SALES_TARGETS: queryParams => ({
    endPoint: 'sale-targets/list?' + queryParams,
    // mockData: SalesTargetData,
    version: API_VERSION.V1,
    method: HTTP_METHODS.POST,
  }),
  // PREREQUISITE_TARGETS: {
  //   endPoint: 'pre-requisite-target',
  //   mockData: PrerequisiteTarget,
  // },
  SALES_TARGETS_CSV_DOWNLOAD: queryParams => ({
    endPoint: `sale-targets/download${queryParams ? `?${queryParams}` : ''}`,
    method: HTTP_METHODS.POST,
  }),
  ADD_SALES_TARGETS: {
    endPoint: 'sale-targets',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1,
  },
  ADD_DRAFT_SALES_TARGETS: {
    endPoint: 'sale-targets/drafts',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1,
  },
  UPDATE_DRAFT_SALES_TARGETS: {
    endPoint: 'sale-targets/drafts',
    method: HTTP_METHODS.PUT,
    version: API_VERSION.V1,
  },
  VALIDATE_PRODUCT_IDS: {
    endPoint: 'sale-targets/validate-product-ids',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1,
  },
  VALIDATE_SALES_TARGET_NAME: {
    endPoint: '/sale-targets/validate-name',
    method: HTTP_METHODS.GET,
    appendQueryParams: true
  },
  SALES_TARGETS_REPORT_DOWNLOAD: {
    endPoint: 'sale-targets/report-download',
  },
  SALES_TARGETS_DOWNLOAD_IMAGE: {
    endPoint: 'sale-targets/downloadMedia',
  },
  SALES_TARGETS_REVIEW_CSV_DOWNLOAD: {
    endPoint: 'sale-targets/downloadMedia',
  },
  SALES_TARGETS_EDIT: queryParams => ({
    endPoint: 'sale-targets/list?' + queryParams,
    version: API_VERSION.V1,
    method: HTTP_METHODS.POST,
  }),
  UPDATE_EDIT_TARGETS_TEMPLATE: (id) => ({
    endPoint: `sale-targets/${id}/import-file`,
    method: HTTP_METHODS.PUT,
    version: API_VERSION.V1,
  }),
}
